var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swj-category-list"},[(_vm.loading)?_c('div',[_c('Spinner')],1):_vm._l((_vm.faqCategories),function(category){return _c('div',{staticClass:"swj-category-list-item"},[_c('Category',{attrs:{"icon-src":category.iconUrl,"name":category.name},on:{"click":function($event){return _vm.openCategory(category)}}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }